const TYPE_STYLES = {
  trigger: {
    accent: 'bg-yellow-sunny/10 border-2 border-ink shadow-brutal-sm',
    icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    label: 'Trigger',
  },
  email: {
    accent: 'bg-primary/5 border-2 border-ink shadow-brutal-teal',
    icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    label: 'Email',
  },
  wait: {
    accent: 'bg-surface border-2 border-ink shadow-brutal-sm',
    icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    label: 'Wait',
  },
  condition: {
    accent: 'bg-accent/5 border-2 border-ink shadow-brutal-pink',
    icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    label: 'Condition',
  },
  exit: {
    accent: 'bg-surface border-2 border-ink shadow-brutal-sm',
    icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    ),
    label: 'End',
  },
};

function getNodeContent(step) {
  switch (step.type) {
    case 'trigger':
      return (
        <div>
          <p className="text-xs font-semibold text-text-secondary">Trigger Event</p>
          <p className="text-sm font-mono text-text-primary mt-0.5">{step.event}</p>
        </div>
      );
    case 'email':
      return (
        <div>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-primary/20 text-primary text-xs font-bold border border-primary/30">
              {step.stepNumber}
            </span>
            <p className="text-sm font-semibold text-text-primary">{step.name || step.templateId}</p>
          </div>
          <p className="text-xs font-mono text-text-secondary mt-0.5">{step.templateId}</p>
        </div>
      );
    case 'wait':
      return (
        <p className="text-sm text-text-primary">
          Wait <span className="font-bold">{step.label || `${step.duration}s`}</span>
        </p>
      );
    case 'condition':
      return (
        <div>
          <p className="text-sm font-semibold text-text-primary">{step.label || 'Condition'}</p>
          <p className="text-xs text-text-secondary mt-0.5">
            {step.field} {step.operator} {String(step.value)}
          </p>
        </div>
      );
    case 'exit':
      return <p className="text-sm text-text-primary">{step.reason || 'End sequence'}</p>;
    default:
      return <p className="text-sm text-text-secondary">Unknown step</p>;
  }
}

export default function FlowNode({ step, selected, onClick }) {
  const style = TYPE_STYLES[step.type] || TYPE_STYLES.exit;

  return (
    <div
      onClick={() => onClick?.(step.id)}
      className={`w-72 rounded-xl p-4 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 mx-auto ${style.accent} ${
        selected ? 'ring-2 ring-teal-glow ring-offset-2' : ''
      }`}
    >
      <div className="flex items-start gap-3">
        <span className="text-text-secondary mt-0.5 shrink-0">{style.icon}</span>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-wider text-text-secondary/70 mb-1">
            {style.label}
          </p>
          {getNodeContent(step)}
        </div>
      </div>
    </div>
  );
}
